export default "__VITE_ASSET__DymJU7Gu__"